import { useAppState } from "../hooks/use_app_state";
import Message from "./message";

import "./chat_window.css";

export function ChatWindow() {
  const { messages, aliIsTyping } = useAppState();

  return (
    <div className="chatWindow">
      {aliIsTyping && (
        <div className="typing-indicator">
          <span />
          <span />
          <span />
        </div>
      )}
      {[...messages].reverse().map((message) => (
        <Message key={message.timestamp} message={message} />
      ))}
    </div>
  );
}
